import React from 'react';
import PropTypes from 'prop-types';
import { getIn, useFormikContext } from 'formik';

import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import Grid from '~/components/core/Atomic/Grid/Grid';
import CloseIcon from '~/components/icons/CloseIcon';
import cn from '~/Utils/cn';

import { BOOL4_OPTIONS } from '../../../../Types';
import RadioButtonFormik from '../../../RadioButtonFormik';
import { ErrorHelperTextFormik } from '../ErrorHelperTextFormik';

import styles from './index.module.scss';

const DEFAULT_OPTIONS = [
  {
    label: BOOL4_OPTIONS.yes,
    optionValue: 'yes',
  },
  {
    label: BOOL4_OPTIONS.no,
    optionValue: 'no',
  },
  {
    label: BOOL4_OPTIONS.na,
    optionValue: 'na',
  },
  {
    label: BOOL4_OPTIONS.unknown,
    optionValue: 'unknown',
  },
];

const isBtnDisabled = ({ disabled, option, disable_na, disable_unknown }) =>
  disabled || (option.optionValue === 'na' && disable_na) || (option.optionValue === 'unknown' && disable_unknown);

const YesNoNaUnknownQuestionFormik = ({
  id,
  questionText,
  disabled = false,
  disable_na = false,
  disable_unknown = false,
  options = DEFAULT_OPTIONS,
  clearable = false,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const currentValue = getIn(values, id);

  const clearSelection = () => {
    setFieldValue(id, null);
  };

  return (
    <Grid container className={styles.container}>
      <Grid item xs={4}>
        <span className={styles.questionText}>
          {questionText}
          <ErrorHelperTextFormik id={id} className={styles.error} />
        </span>
      </Grid>
      <Grid item xs={clearable ? 7 : 8}>
        <div className={styles.radioBtnContainer}>
          {options.map((option) => (
            <RadioButtonFormik
              key={option.label}
              id={id}
              label={option.label}
              optionValue={option.optionValue}
              disabled={isBtnDisabled({
                disabled,
                option,
                disable_na,
                disable_unknown,
              })}
              size="small"
            />
          ))}
        </div>
      </Grid>
      {clearable && (
        <Grid item xs={1}>
          <IconButton
            size="small"
            className={cn(
              'ml-8 p-4',
              !disabled && options.some((option) => option.optionValue === currentValue) ? 'visible' : 'invisible'
            )}
            title="Clear"
            disabled={disabled}
            onClick={clearSelection}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

YesNoNaUnknownQuestionFormik.propTypes = {
  id: PropTypes.string.isRequired,
  questionText: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  disable_na: PropTypes.bool,
  disable_unknown: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      optionValue: PropTypes.string.isRequired,
    })
  ),
  clearable: PropTypes.bool,
};

YesNoNaUnknownQuestionFormik.DEFAULT_OPTIONS = DEFAULT_OPTIONS;

export default YesNoNaUnknownQuestionFormik;
